/** Sticky category title stack — updates header without re-rendering the product list. */
import { __read, __spreadArray, __values } from "tslib";
var stickies = [];
var listeners = new Set();
var flushTimer = null;
var queue = [];
function currentTitle() {
    return stickies.length ? stickies[stickies.length - 1] : undefined;
}
function notify() {
    var title = currentTitle();
    listeners.forEach(function (listener) { return listener(title); });
}
function flushQueue() {
    var e_1, _a;
    flushTimer = null;
    if (!queue.length) {
        return;
    }
    var ops = queue.splice(0, queue.length);
    var prev = stickies.slice();
    try {
        for (var ops_1 = __values(ops), ops_1_1 = ops_1.next(); !ops_1_1.done; ops_1_1 = ops_1.next()) {
            var op = ops_1_1.value;
            if (op.type === 'stick') {
                if (stickies[stickies.length - 1] !== op.name) {
                    stickies = __spreadArray(__spreadArray([], __read(stickies), false), [op.name], false);
                }
            }
            else {
                var index = stickies.indexOf(op.name);
                if (index >= 0) {
                    stickies = stickies.slice();
                    stickies.splice(index, 1);
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (ops_1_1 && !ops_1_1.done && (_a = ops_1.return)) _a.call(ops_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    if (stickies.length === prev.length &&
        stickies.every(function (name, i) { return name === prev[i]; })) {
        return;
    }
    notify();
}
function scheduleFlush() {
    if (flushTimer) {
        clearTimeout(flushTimer);
    }
    flushTimer = setTimeout(flushQueue, 150);
}
export function pushStickyTitle(name) {
    queue.push({ type: 'stick', name: name });
    scheduleFlush();
}
export function popStickyTitle(name) {
    queue.push({ type: 'unstick', name: name });
    scheduleFlush();
}
export function resetStickyTitles() {
    if (flushTimer) {
        clearTimeout(flushTimer);
        flushTimer = null;
    }
    queue.length = 0;
    if (!stickies.length) {
        return;
    }
    stickies = [];
    notify();
}
export function subscribeStickyTitle(listener) {
    listeners.add(listener);
    listener(currentTitle());
    return function () {
        listeners.delete(listener);
    };
}
//# sourceMappingURL=stickyTitleStore.js.map